module.exports = __webpack_public_path__ + "static/media/windy.9680648e.svg";